import { create } from 'zustand';
import React from 'react';

export interface CommandItem {
  id: string;
  value: string;
  label: string;
  action: () => void;
  icon?: React.ReactNode;
}

interface UIState {
  isCommandPaletteOpen: boolean;
  toggleCommandPalette: () => void;
  openCommandPalette: () => void;
  closeCommandPalette: () => void;
  recentCommands: CommandItem[];
  addRecentCommand: (command: CommandItem) => void;
  focusPromptInput: (() => void) | null;
  setFocusPromptInput: (action: (() => void) | null) => void;
}

export const useUIStore = create<UIState>((set) => ({
  isCommandPaletteOpen: false,
  toggleCommandPalette: () => set((state) => ({ isCommandPaletteOpen: !state.isCommandPaletteOpen })),
  openCommandPalette: () => set({ isCommandPaletteOpen: true }),
  closeCommandPalette: () => set({ isCommandPaletteOpen: false }),
  recentCommands: [],
  addRecentCommand: (command) => set(state => {
    const newRecentCommands = [
        command,
        ...state.recentCommands.filter(c => c.id !== command.id)
    ].slice(0, 3); // Keep last 3 recent commands
    return { recentCommands: newRecentCommands };
  }),
  focusPromptInput: null,
  setFocusPromptInput: (action) => set({ focusPromptInput: action }),
}));